// hooks/useUserLocation.js

import { useState, useEffect } from 'react';

export const useUserLocation = () => {
    const [userLocation, setUserLocation] = useState(null);
    const [error, setError] = useState(null);

    const fetchIPLocation = async () => {
        try {
            const response = await fetch('https://ipapi.co/json/');
            if (!response.ok) throw new Error('Failed to fetch IP location');
            const data = await response.json();
            setUserLocation({
                latitude: parseFloat(data.latitude),
                longitude: parseFloat(data.longitude),
                city: data.city,
                region: data.region,
                country: data.country_name,
                ip: data.ip
            });
        } catch (err) {
            console.error('Error fetching IP location:', err);
            setError(err);
        }
    };

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setUserLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                (geoError) => {
                    console.warn('Geolocation failed, falling back to IP location:', geoError);
                    fetchIPLocation();
                }
            );
        } else {
            console.warn('Geolocation not supported, using IP location');
            fetchIPLocation();
        }
    }, []);

    return { userLocation, error };
};
